import { render, staticRenderFns } from "./item.vue?vue&type=template&id=4bc8804c&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc8804c')) {
      api.createRecord('4bc8804c', component.options)
    } else {
      api.reload('4bc8804c', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=4bc8804c&", function () {
      api.rerender('4bc8804c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/skeleton/src/item.vue"
export default component.exports